(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ara-antes-despues"] && !Shopify.designMode) return;
  try {
    
  class AraAntesDespues extends HTMLElement {
    connectedCallback() {
      var self = this;
      var rango = this.querySelector('.ara-ad__rango');
      if (!rango || this._listo) return;
      this._listo = true;
      function poner(v) { self.style.setProperty('--pos', v + '%'); }
      rango.addEventListener('input', function () { self.tocado = true; poner(rango.value); });
      /* Al aparecer, la línea va y vuelve un poco una sola vez. Motivo: enseñar que se arrastra sin escribirlo. */
      var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (quieto || !document.documentElement.classList.contains('ara-anima') || !('IntersectionObserver' in window)) return;
      var inicio = Number(this.getAttribute('data-inicio')) || 50;
      this._io = new IntersectionObserver(function (e, obs) {
        if (!e[0].isIntersecting) return;
        obs.disconnect();
        var pasos = [inicio + 12, inicio - 10, inicio];
        var t0 = null, dur = 1500;
        function cuadro(t) {
          if (self.tocado) return;
          if (!t0) t0 = t;
          var k = Math.min(1, (t - t0) / dur);
          var x = k < 1 / 3 ? inicio + (pasos[0] - inicio) * suave(k * 3)
            : k < 2 / 3 ? pasos[0] + (pasos[1] - pasos[0]) * suave(k * 3 - 1)
            : pasos[1] + (pasos[2] - pasos[1]) * suave(k * 3 - 2);
          poner(x);
          rango.value = Math.round(x);
          if (k < 1) requestAnimationFrame(cuadro);
        }
        function suave(u) { return u < 0.5 ? 2 * u * u : 1 - Math.pow(-2 * u + 2, 2) / 2; }
        setTimeout(function () { requestAnimationFrame(cuadro); }, 400);
      }, { threshold: 0.6 });
      this._io.observe(this);
    }
    disconnectedCallback() { if (this._io) this._io.disconnect(); }
  }
  if (!customElements.get('ara-antes-despues')) customElements.define('ara-antes-despues', AraAntesDespues);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ara-preguntas"] && !Shopify.designMode) return;
  try {
    
  class AraPreguntas extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.classList.add('is-listo');
      /* Acordeón: cada pregunta se abre y se cierra al tocarla; se pueden tener varias abiertas */
      this.querySelectorAll('.ara-faq__item').forEach(function (item) {
        var q = item.querySelector('[data-q]');
        var a = item.querySelector('[data-a]');
        if (!q || !a || q.dataset.listo) return;
        q.dataset.listo = '1';
        a.inert = true;
        q.addEventListener('click', function () {
          var abrir = q.getAttribute('aria-expanded') !== 'true';
          q.setAttribute('aria-expanded', String(abrir));
          item.classList.toggle('is-abierta', abrir);
          a.inert = !abrir;
        });
      });
      /* «Ver más»: las de abajo se esconden y salen al pulsarlo, en cascada. Sin JavaScript se ven todas. */
      var extras = [].slice.call(this.querySelectorAll('[data-extra]'));
      var caja = this.querySelector('[data-mas-caja]');
      if (!extras.length || !caja || window.Shopify && Shopify.designMode) return;
      extras.forEach(function (el) { el.hidden = true; });
      caja.hidden = false;
      caja.querySelector('[data-mas]').addEventListener('click', function (e) {
        extras.forEach(function (el, i) {
          el.hidden = false;
          el.classList.add('is-antes');
          el.style.setProperty('--d2', i * 40 + 'ms');
        });
        void self.offsetWidth;
        extras.forEach(function (el) { el.classList.remove('is-antes'); });
        caja.remove();
        /* Con teclado, el foco pasa a la primera pregunta nueva */
        if (e.detail === 0) {
          var primera = extras[0].querySelector('[data-q]');
          if (primera) primera.focus();
        }
      });
    }
  }
  if (!customElements.get('ara-preguntas')) customElements.define('ara-preguntas', AraPreguntas);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ara-videos"] && !Shopify.designMode) return;
  try {
    
  class AraVideos extends HTMLElement {
    connectedCallback() {
      var self = this;
      var cinta = this.querySelector('[data-cinta]');
      if (!cinta || this._listo) return;
      this._listo = true;
      var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var animar = document.documentElement.classList.contains('ara-anima');
      var vel = Number(this.getAttribute('data-vel')) || 0;
      var mover = animar && !quieto && vel > 0;
      var tarjetas = [].slice.call(cinta.children);
      /* Para que la cinta no se acabe nunca, se repite una vez: al llegar al final de la primera vuelta
         salta, sin que se note, al mismo punto de la segunda */
      if (mover && tarjetas.length > 1) {
        tarjetas.forEach(function (li) {
          var c = li.cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          c.removeAttribute('data-shopify-editor-block');
          cinta.appendChild(c);
        });
      }
      /* Cada video carga y se reproduce (siempre en silencio) solo cuando está a la vista */
      var vids = [].slice.call(cinta.querySelectorAll('video'));
      function cargar(v) {
        if (v.src) return;
        var u = v.getAttribute('data-src');
        v.src = v.hasAttribute('poster') ? u : u + '#t=0.1';
      }
      if ('IntersectionObserver' in window) {
        this._ioVid = new IntersectionObserver(function (entradas) {
          entradas.forEach(function (en) {
            var v = en.target;
            if (en.isIntersecting) {
              cargar(v);
              v.muted = v.defaultMuted = true;
              if (!quieto) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
            } else if (!v.paused) v.pause();
          });
        }, { rootMargin: '0px 120px 0px 120px', threshold: 0.2 });
        vids.forEach(function (v) { self._ioVid.observe(v); });
      } else vids.forEach(cargar);
      if (!mover) return;

      /* Avance continuo hacia la izquierda. Se para mientras el dedo está encima y sigue 2,5 s después
         de soltar; también se para fuera de la pantalla. Motivo: amplitud, enseñar todos sin pedir gestos. */
      var pos = 0, ultimo = 0, parado = false, visible = false, reanudar = null;
      this._raf = null;
      function vuelta() { return tarjetas.length > 1 ? cinta.scrollWidth / 2 : 0; }
      function paso(t) {
        self._raf = null;
        if (!ultimo) ultimo = t;
        var dt = Math.min(0.05, (t - ultimo) / 1000);
        ultimo = t;
        if (!parado && visible && !document.hidden) {
          var w = vuelta();
          pos += vel * dt;
          if (w && pos >= w) pos -= w;
          self.scrollLeft = pos;
        }
        seguir();
      }
      function seguir() { if (visible && !self._raf) self._raf = requestAnimationFrame(paso); }
      function parar() { parado = true; clearTimeout(reanudar); }
      function soltar() {
        clearTimeout(reanudar);
        reanudar = setTimeout(function () { pos = self.scrollLeft; ultimo = 0; parado = false; }, 2500);
      }
      this.addEventListener('pointerdown', parar, { passive: true });
      this.addEventListener('touchstart', parar, { passive: true });
      this.addEventListener('pointerup', soltar, { passive: true });
      this.addEventListener('pointercancel', soltar, { passive: true });
      this.addEventListener('touchend', soltar, { passive: true });
      this.addEventListener('wheel', function () { parar(); soltar(); }, { passive: true });
      /* Si el dedo la llevó más allá de una vuelta (o al principio), se recoloca sin que se note */
      this.addEventListener('scroll', function () {
        if (!parado) return;
        var w = vuelta();
        if (!w) return;
        if (self.scrollLeft >= w + 1) self.scrollLeft -= w;
        else if (self.scrollLeft <= 0) self.scrollLeft += w;
      }, { passive: true });
      this._ioVer = new IntersectionObserver(function (e) { visible = e[0].isIntersecting; ultimo = 0; seguir(); });
      this._ioVer.observe(this);
    }
    disconnectedCallback() {
      if (this._ioVid) this._ioVid.disconnect();
      if (this._ioVer) this._ioVer.disconnect();
      if (this._raf) cancelAnimationFrame(this._raf);
    }
  }
  if (!customElements.get('ara-videos')) customElements.define('ara-videos', AraVideos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
